<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_vi">
<p class="dedication">Transylvanian Hungarian saying: “The only virgin sheep and goats in the Carpathians are the ones that can outrun the Romanian shepherd.”</p>
</a></div><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7b764b3c